import { render, staticRenderFns } from "./validate-code.vue?vue&type=template&id=6966c4ca&scoped=true&"
import script from "./validate-code.ts?vue&type=script&lang=ts&"
export * from "./validate-code.ts?vue&type=script&lang=ts&"
import style0 from "./validate-code.scss?vue&type=style&index=0&id=6966c4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6966c4ca",
  null
  
)

export default component.exports